import { c as _c } from "react/compiler-runtime";
import type { ComponentProps } from 'react';
import type { IdDocImageSide } from '@/idv2/features/collect-document/types';
import type DesktopPhotoPrompt from '../../../components/desktop-photo-prompt';
import type { IdDocImageUploadError } from '../../../types';
import useDocName from '../../hooks/use-doc-name';
import useIdDocMachine from '../../hooks/use-id-doc-machine';
import DesktopCaptureView from './desktop-capture-view';
type DesktopCaptureProps = {
  imageType: `${IdDocImageSide}`;
  isRetry?: boolean;
  onBack?: () => void;
  onComplete: ComponentProps<typeof DesktopPhotoPrompt>['onUploadSuccess'];
};
const DesktopCapture = t0 => {
  const $ = _c(20);
  const {
    imageType,
    isRetry: t1,
    onBack,
    onComplete
  } = t0;
  const isRetry = t1 === undefined ? false : t1;
  const [state, dispatch] = useIdDocMachine();
  const {
    errors,
    hasBadConnectivity,
    idDoc,
    allowPdf
  } = state.context;
  const docType = idDoc.type;
  const countryCode = idDoc.country;
  let t2;
  if ($[0] !== docType || $[1] !== imageType) {
    t2 = {
      docType,
      imageType
    };
    $[0] = docType;
    $[1] = imageType;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const {
    getDocName,
    getSideName
  } = useDocName(t2);
  if (!docType || !countryCode) {
    return null;
  }
  let t3;
  if ($[3] !== dispatch) {
    t3 = errs => {
      dispatch({
        type: "uploadErrored",
        payload: {
          errors: errs.map(_temp)
        }
      });
    };
    $[3] = dispatch;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const handleUploadError = t3;
  let t4;
  if ($[5] !== getDocName) {
    t4 = getDocName();
    $[5] = getDocName;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== getSideName) {
    t5 = getSideName();
    $[7] = getSideName;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== allowPdf || $[10] !== countryCode || $[11] !== errors || $[12] !== handleUploadError || $[13] !== hasBadConnectivity || $[14] !== isRetry || $[15] !== onBack || $[16] !== onComplete || $[17] !== t4 || $[18] !== t5) {
    t6 = <DesktopCaptureView docName={t4} sideName={t5} country={countryCode} errors={errors} hasBadConnectivity={hasBadConnectivity} allowPdf={allowPdf} isRetry={isRetry} onBack={onBack} onComplete={onComplete} onUploadError={handleUploadError} />;
    $[9] = allowPdf;
    $[10] = countryCode;
    $[11] = errors;
    $[12] = handleUploadError;
    $[13] = hasBadConnectivity;
    $[14] = isRetry;
    $[15] = onBack;
    $[16] = onComplete;
    $[17] = t4;
    $[18] = t5;
    $[19] = t6;
  } else {
    t6 = $[19];
  }
  return t6;
};
export default DesktopCapture;
function _temp(err) {
  return {
    errorType: err
  };
}